import script from "./show.vue?vue&type=script&setup=true&lang=ts"
export * from "./show.vue?vue&type=script&setup=true&lang=ts"

import "./show.vue?vue&type=style&index=0&id=2bb759bc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/binity-order/binity-order/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bb759bc"]])

export default __exports__